/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoPatologiaInfettivaUpdateDTO
 */
export interface AssistitoPatologiaInfettivaUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoPatologiaInfettivaUpdateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoPatologiaInfettivaUpdateDTO
     */
    sintomi?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoPatologiaInfettivaUpdateDTO
     */
    terapia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoPatologiaInfettivaUpdateDTO
     */
    note?: string;
}

/**
 * Check if a given object implements the AssistitoPatologiaInfettivaUpdateDTO interface.
 */
export function instanceOfAssistitoPatologiaInfettivaUpdateDTO(value: object): value is AssistitoPatologiaInfettivaUpdateDTO {
    return true;
}

export function AssistitoPatologiaInfettivaUpdateDTOFromJSON(json: any): AssistitoPatologiaInfettivaUpdateDTO {
    return AssistitoPatologiaInfettivaUpdateDTOFromJSONTyped(json, false);
}

export function AssistitoPatologiaInfettivaUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoPatologiaInfettivaUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'sintomi': json['sintomi'] == null ? undefined : json['sintomi'],
        'terapia': json['terapia'] == null ? undefined : json['terapia'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function AssistitoPatologiaInfettivaUpdateDTOToJSON(value?: AssistitoPatologiaInfettivaUpdateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'sintomi': value['sintomi'],
        'terapia': value['terapia'],
        'note': value['note'],
    };
}

